import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { useFormikContext } from "formik";
import { map } from "lodash";
import { useCallback, useRef } from "react";
import { CreateCampaignData } from "../../../types/campaign";
import { CAMPAIGN_VARIABLE } from "../../../utils/constants";
import { ButtonFile } from "../../ButtonFile";

export function WhatsApp() {
  const formik = useFormikContext<CreateCampaignData>();

  const inputMessageRef = useRef<HTMLInputElement>(null);

  const handleAddVariable = useCallback(
    (variable: string) => {
      const tempMessage = formik.values.message;
      const cursor = inputMessageRef.current.selectionStart;
      formik.setFieldValue(
        "message",
        `${tempMessage.substring(0, cursor)}${variable}${tempMessage.substring(
          cursor
        )}`
      );
    },
    [formik]
  );

  return (
    <Stack spacing={4}>
      <TextField
        autoFocus
        inputRef={inputMessageRef}
        rows={5}
        multiline
        label="Texto"
        onChange={({ target: { value } }) =>
          formik.setFieldValue("message", value)
        }
        fullWidth
        size="small"
        value={formik.values.message}
        error={!!formik.errors.message}
        helperText={!!formik.errors.message && formik.errors.message}
      />
      <Stack justifyContent="center" direction="row" spacing={1}>
        {map(CAMPAIGN_VARIABLE, (variable) => (
          <Chip
            key={variable.value}
            color="primary"
            size="small"
            variant="filled"
            label={variable.name}
            onClick={() => {
              handleAddVariable(variable.value);
            }}
          />
        ))}
      </Stack>
      <ButtonFile
        accept={["image/*", "video/*"]}
        label={formik.values.whatsAppFile?.name}
        onChange={(file) => formik.setFieldValue("whatsAppFile", file)}
        error={!!formik.errors.whatsAppFile}
        helperText={
          !!formik.errors.whatsAppFile && (formik.errors.whatsAppFile as string)
        }
      />
    </Stack>
  );
}
